import { render, staticRenderFns } from "./GoogleAdConfig.vue?vue&type=template&id=f71337fc&"
import script from "./GoogleAdConfig.vue?vue&type=script&lang=ts&"
export * from "./GoogleAdConfig.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports